"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _cookie = _interopRequireDefault(require("cookie"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var extractSessionId = function extractSessionId(ctx, sessionCookie) {
  var cookies = ctx.request.headers.cookie;
  return cookies ? _cookie["default"].parse(cookies)[sessionCookie] : null;
};

var _default = extractSessionId;
exports["default"] = _default;